import React from "react";
import Button from "../../../pageComponents/Settings/Free/Button";
import Grid from "@material-ui/core/Grid";
import Comma from "../../../../assets/images/comma.png";
import {withRouter} from "react-router-dom";
import {lcLuckSpinner} from "../../../../Utility/Url";

class ItemHolder extends React.Component {
    constructor() {
        super();
    }
    componentDidMount() {
    }

    render() {
        const {icon,text,buttonText,buttonTextColor,buttonColor,firstLayerColor,secondLayerColor,thirdLayerColor,id}=this.props.data

        const button={
            text:buttonText,
            backgroundColor:buttonColor,
            bottomFontSize:'15px',
            buttonTextColor:buttonTextColor
        }
        return(
            <Grid justify={'center'} className='item-holder' xs={12} sm={12}  item container
                  style={{backgroundColor:firstLayerColor}}>
                <Grid alignItems={"center"} justify={"center"} xs={12} sm={12} item container className='item-holder-first-layer'
                      style={{backgroundColor:secondLayerColor}}>
                    <Grid sm={12} xs={12} justify={"center"} alignItems={"center"} item container className='item-holder-first-layer-second-layer'
                          style={{backgroundColor:thirdLayerColor}}>
                        <Grid  container alignItems={"center"} xs={12} sm={12} item>
                           <Grid sm={10}  xs={10} justify={"center"} alignItems={"center"} item container>
                               <Grid item sm={9} xs={9}>
                                   <p className='item-holder-first-layer-second-layer-text'>{text}</p>
                               </Grid>
                               <Grid item sm={3} xs={3}>
                                   <img src={icon} style={{width:'100%'}} alt=""/>
                               </Grid>
                           </Grid>
                           <Grid container sm={10} xs={10} justify={"center"} item style={{width:'100%',height:'60px'}}>
                               <Grid sm={7} xs={7} item className='clickable'
                                onClick={()=>{
                                    if (id=='luckSpinner')
                                        this.props.history.push(lcLuckSpinner)
                                }}
                               >
                                   <Button data={button}/>
                               </Grid>
                               <Grid sm={4} xs={4} item>
                               </Grid>
                           </Grid>
                       </Grid>

                    </Grid>
                </Grid>
            </Grid>
        )
    }
}
export default withRouter (ItemHolder)